

import Component from 'generic.basecomponent';
import ContentModal from '../../modal/js/content-modal';
import deleteAccountTemplate from '../html/delete-account.hbs';


export default class Account extends Component {
    constructor(el) {
        super(el);
        this.showDeleteModal = this.showDeleteModal.bind(this);
        this.deleteAccTrigger = this.container.querySelector('.js-account__delete-trigger');

        this.modal = new ContentModal('');


        this.init();
    }

    init() {
        if (this.deleteAccTrigger) {
            this.deletePostbackId = this.deleteAccTrigger.getAttribute('data-clientid');
            this.localization = {};
            const localizationString = this.deleteAccTrigger.getAttribute('data-localization');
            try {
                this.localization = JSON.parse(localizationString);
            } catch (e) {
                console.log(e);
            }
            this.deleteAccTrigger.addEventListener('click', this.showDeleteModal);
        }
    }

    showDeleteModal() {
        const content = deleteAccountTemplate(
            {
                clientId: this.deletePostbackId,
                localization: this.localization
            }
        );
        this.modal.setContent(content);
        this.modal.open();
    }

    destroy() {
        super.destroy();

        this.deleteAccTrigger.removeEventListener('click', this.showDeleteModal);
        this.container.classList.remove('js-payment-summary-inited');
    }
}



// WEBPACK FOOTER //
// ./app/components/account/js/generic.account.js